import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { FormsModule, UntypedFormBuilder } from '@angular/forms';
import { BookingService, CustomerService, User } from '@beautyapp/core';
import { takeUntil } from 'rxjs/operators';
import { AddAppointmentComponent } from "../../booking-modal";
import { ClearAddAppointmentSpecService } from "../../appointment.actions";
import { NzModalService } from "ng-zorro-antd/modal";
import { TranslateService, TranslateModule, TranslatePipe } from "@ngx-translate/core";
import { Store } from "@ngxs/store";
import { SelectSearchComponent } from '@beautyapp/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { CommonModule, AsyncPipe } from '@angular/common';

@Component({
    selector: 'beautyapp-appointment-search',
    templateUrl: './appointment-search.component.html',
    styleUrls: ['./appointment-search.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        SelectSearchComponent,
        NzGridModule,
        NzListModule,
        NzEmptyModule,
        TranslateModule,
        TranslatePipe,
        AsyncPipe
    ]
})
export class AppointmentSearchComponent implements OnInit {
  private fb = inject(UntypedFormBuilder);
  private customerService = inject(CustomerService);
  private bookingService = inject(BookingService);
  private modalService = inject(NzModalService);
  private translateService = inject(TranslateService);
  private store = inject(Store);

  @Output() selectChanged: EventEmitter<any> = new EventEmitter<any>();
  appointmentSearch?: string;
  selected: any;
  searchResult$!: Observable<any>;
  userBookings$!: Observable<any>;
  customers: User[] = [];
  selectedCustomer?: User;
  sub$: Subject<any> = new Subject<any>();

  ngOnInit() {}

  searchCustomer(search: any) {
    this.customerService
      .search(search)
      .pipe(takeUntil(this.sub$))
      .subscribe((res) => {
        this.customers = res;
      });
  }

  searchAppointment(event: string) {
    if (event) {
      const params = {
        search: event,
        size: 5,
      };
      this.userBookings$ = this.bookingService.getUserBooking(params);
    } else {
      this.userBookings$ = of(null);
    }
  }

  selectItem(item: any) {
    this.selected = item;
    this.searchResult$ = of(null);
    this.selectChanged.emit(this.selected);
    this.appointmentSearch = item.firstname + ' ' + item.lastname;
  }

  clearCustomer() {
    this.selected = undefined;
    this.selectChanged.emit([]);
    this.appointmentSearch = undefined;
  }

  searchByUser(search: any) {
    console.log(search);
    const params = {
      search,
      size: 5,
    };
    this.userBookings$ = this.bookingService.getUserBooking(params);
  }

  openBook(book: any) {
    console.log(book);
    const modal = this.modalService.create({
      nzClosable: false,
      nzMaskClosable: false,
      nzTitle: this.translateService.instant('calendar.planVisit'),
      nzContent: AddAppointmentComponent,
      nzWidth: '1100px',
      nzStyle: {top: '0px'},
      nzBodyStyle: {padding: '0'},
      nzData: {
        bookingId: book.id,
      },
    });
    modal.afterClose.subscribe((res) => {
      this.store.dispatch(new ClearAddAppointmentSpecService());
    });
  }
}
